export const bassCatalog = {
  sub1: {gain: 0.5},
  sub2: {gain: 0.8},
  sub3: {gain: 0.6}
}

export const fx = {
  fx1: {gain: 0.3},
  fx2: {gain: 0.2},
  fx3: {gain: 0.3},
  fx4: {gain: 0.3},
  fx5: {gain: 0.2},
  fx6: {gain: 0.3},
  fx7: {gain: 0.3},
  fx8: {gain: 0.3},
  fx9: {gain: 0.3},
}

export const stabs = {
  stab1: {gain: 0.6},
  stab2: {gain: 0.6},
  stab3: {gain: 0.6},
  stab4: {gain: 0.7},
  stab5: {gain: 0.6},
  stab6: {gain: 0.6},
  stab7: {gain: 0.4},
  stab8: {gain: 0.6},
  stab9: {gain: 0.6},
}

export default {
  amen1: {
    bars: 2,
    bpm: 165,
    hits: 'krstksttc0skkstt',
    gain: 0.7,
  },
  apache1: {
    bars: 2,
    bpm: 165,
    hits: 'krsttkstkksttkst'
  },
  dothe1: {
    bars: 1,
    bpm: 165,
    hits: 'krsttkst'
  },
  funky1: {
    bars: 2,
    bpm: 165,
    hits: 'kksttkstkksttkst'
  },
  hot1: {
    bars: 2,
    bpm: 165,
    hits: 'krsttkskkrstrstt'
  },
  runs1: {
    bars: 2,
    bpm: 165,
    hits: 'c0sttkstkksttks0'
  },
  think1: {
    bars: 2,
    bpm: 165,
    hits: 'krsttrs0krsttrsr'
  }
}
